// extracted by mini-css-extract-plugin
export var buttons = "_al-0";
export var buttonsActive = "_al-h";
export var cancelConfirm = "_al-1";
export var closeButton = "_al-2";
export var column = "_al-3";
export var container = "_al-4";
export var detailHeader = "_al-6";
export var detailTitle = "_al-7";
export var detailsContent = "_al-5";
export var header = "_al-8";
export var headerWithClose = "_al-9";
export var icon = "_al-a";
export var infoIcon = "_al-c";
export var informationContainer = "_al-b";
export var sideDrawer = "_al-d";
export var sideDrawerOpen = "_al-e";
export var stickyFooter = "_al-f";
export var typeOption = "_al-g";